import "./AboutUs.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import WhoIAm from "./sections/WhoIAm";
import ExpertTeam from "./sections/ExpertTeam";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <FraternalExcellenceHeader />
      <WhoIAm />
      <ExpertTeam />
      <Consultation />
      <Footer />
    </div>;
}